/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrganizationMembershipUserSchema } from './OrganizationMembershipUserSchema';
import {
    OrganizationMembershipUserSchemaFromJSON,
    OrganizationMembershipUserSchemaFromJSONTyped,
    OrganizationMembershipUserSchemaToJSON,
} from './OrganizationMembershipUserSchema';
import type { WorkspaceMembershipSchema } from './WorkspaceMembershipSchema';
import {
    WorkspaceMembershipSchemaFromJSON,
    WorkspaceMembershipSchemaFromJSONTyped,
    WorkspaceMembershipSchemaToJSON,
} from './WorkspaceMembershipSchema';

/**
 * 
 * @export
 * @interface OrganizationMembershipSchema
 */
export interface OrganizationMembershipSchema {
    /**
     * 
     * @type {number}
     * @memberof OrganizationMembershipSchema
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationMembershipSchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationMembershipSchema
     */
    updated: Date;
    /**
     * 
     * @type {OrganizationMembershipUserSchema}
     * @memberof OrganizationMembershipSchema
     */
    user: OrganizationMembershipUserSchema;
    /**
     * 
     * @type {Array<WorkspaceMembershipSchema>}
     * @memberof OrganizationMembershipSchema
     */
    workspaceMemberships: Array<WorkspaceMembershipSchema>;
    /**
     * 
     * @type {string}
     * @memberof OrganizationMembershipSchema
     */
    role: string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationMembershipSchema
     */
    organizationId: number;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationMembershipSchema
     */
    displayedProTrialExpiration?: Date;
}

/**
 * Check if a given object implements the OrganizationMembershipSchema interface.
 */
export function instanceOfOrganizationMembershipSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "user" in value;
    isInstance = isInstance && "workspaceMemberships" in value;
    isInstance = isInstance && "role" in value;
    isInstance = isInstance && "organizationId" in value;

    return isInstance;
}

export function OrganizationMembershipSchemaFromJSON(json: any): OrganizationMembershipSchema {
    return OrganizationMembershipSchemaFromJSONTyped(json, false);
}

export function OrganizationMembershipSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationMembershipSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'user': OrganizationMembershipUserSchemaFromJSON(json['user']),
        'workspaceMemberships': ((json['workspace_memberships'] as Array<any>).map(WorkspaceMembershipSchemaFromJSON)),
        'role': json['role'],
        'organizationId': json['organization_id'],
        'displayedProTrialExpiration': !exists(json, 'displayed_pro_trial_expiration') ? undefined : (new Date(json['displayed_pro_trial_expiration'])),
    };
}

export function OrganizationMembershipSchemaToJSON(value?: OrganizationMembershipSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'user': OrganizationMembershipUserSchemaToJSON(value.user),
        'workspace_memberships': ((value.workspaceMemberships as Array<any>).map(WorkspaceMembershipSchemaToJSON)),
        'role': value.role,
        'organization_id': value.organizationId,
        'displayed_pro_trial_expiration': value.displayedProTrialExpiration === undefined ? undefined : (value.displayedProTrialExpiration.toISOString()),
    };
}

